/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2573
 */

var r = require(/* 864 */"../../../../../797/101/2538/2539/2540/2541/864")
var i = require(/* 865 */"../865/index")
module.exports = function (e) {
  return r(e, i(e))
}
